<template>
  <div class="mt-5">
    <p
      class="font-weight-medium ml-5"
      style="font-size: 20px"
    >
      <span class="pt-5" id="similarInvestors">Similar Investors</span>
      <investor-expand-similar-list :title="'Similar Investors'" :items="investors"></investor-expand-similar-list>
    </p>
    <v-row v-if="listLoad">
      <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="card"         width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="card"         width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="card"         width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="card"         width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>            
    </v-row>

    <v-row v-if="!listLoad">
      <v-col cols="12" md="4"
        v-for="(item, i) in investors.slice(0, 6)"
        :key="i"
      >
        <v-card
          class="d-block mx-auto"
          style="height: 100%;"
        >
          <v-toolbar color='#233767' dark flat>
            <div class="mr-3 d-inline-block  text-truncate">
              <div>
                {{ item.investor }}
                <div class="caption" style="color: #8DA2C2;">{{ item.management_company }}</div>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-menu offset-x>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-for="(menuitem, i) in menuItems"
                    :key="i"
                    :to="'/investors/analyze/' + item.id"
                  >
                    <v-list-item-title>{{ menuitem.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-btn>
          </v-toolbar>
          <v-row class="px-5">
            <v-col cols="12" lg="5">
              <radial-progress-bar
                :diameter="100"
                :completed-steps="10"
                :total-steps="10"
                :startColor="item.colorStart"
                :stopColor="item.colorEnd"
                :strokeWidth="8"
                class="mx-auto"
              >
                {{ item.overlap }}<br><small>overlap</small>
              </radial-progress-bar>
            </v-col>
            <v-col cols="12" lg="7" class="d-flex align-center pt-0">
              <div>
                <div class="body-1">{{ item.classification }}</div>
                <div class="caption" style="color: #8DA2C2">No of Holdings: {{ item.nb_positions }}</div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" v-if="investors.length ===0">
        <v-card
          class="d-block mx-auto"
          style="height: 100%;"
        >
          <v-card-text>
            <span
              class="mr-3"
              
            >
              No similar investors
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <!-- <p
      class="font-weight-medium ml-5"
      style="font-size: 20px"
    >
      Similar Investors based on trading behavior
    </p>
    <v-row v-if="!listLoad"  >
      <v-col cols="12" md="4"
        v-for="(item, i) in investorsTrading"
        :key="i"
      >
        <v-card
          class="d-block mx-auto"
          style="height: 100%;"
        >
          <v-toolbar color='#233767'
            dark dense flat
          >
            <span class="mr-3 d-inline-block  text-truncate">
              {{ item.investor }}
            </span>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-menu offset-x>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-for="(menuitem, i) in menuItems"
                    :key="i"
                    @click="gotoInvestorPage(item.id)"
                  >
                    <v-list-item-title>{{ menuitem.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-btn>
          </v-toolbar>
          <v-row>
            <v-col cols="12" md="5">
              <radial-progress-bar
                :diameter="100"
                :completed-steps="10"
                :total-steps="10"
                :startColor="item.colorStart"
                :stopColor="item.colorEnd"
                :strokeWidth="8"
                style="margin: 0 auto;"
              >
                {{ item.overlap }}<br><small>overlap</small>
              </radial-progress-bar>
            </v-col>
            <v-col cols="12" md="7">
              <p  style="font-size: 16px;">{{ item.classification }}</p>
              <p style="color: #8DA2C2; font-size: 12px;">{{ item.management_company }}</p>
              <p style="color: #8DA2C2; font-size: 16px;">No of Holdings: {{ item.nb_positions }}</p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" v-if="investors.length ===0">
        <v-card
          class="d-block mx-auto"
          style="height: 100%;"
        >
          <v-card-text>
            <span
              class="mr-3"
            >
              No similar investors
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->

  </div>
</template>

<script>
  import RadialProgressBar from 'vue-radial-progress'
  export default {
    name: 'PortfolioAnalyzeComponentSimilarInvestors',
    props: ['ptf'],
    components: {
      RadialProgressBar,
      InvestorExpandSimilarList: () => import('@/views/dashboard/components/investors/analyze/SimilarInvestorsExpand'),
    },
    data() {
      return {
        listLoad: true,        
        menuItems: [
          {
            title: 'Go to investor page',
            path: '/investors/analyze/'
          },
        ],
        investors: [
        ],
        investorsTrading: [
        ],        
      }
    },  
    mounted () {
      this.getListFromApi()
    },    
    methods: {
      gotoInvestorPage(id) {
        this.$router.push({name: 'InvestorsAnalyze', params: {investor: id}})
      },                
      async getListFromApi() {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST +  '/get-user-ptf-overlap/' + self.ptf,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          self.investors = response.data.investors
          self.listLoad = false
        }).catch(function (/*error*/) {
          //console.log(error)
          self.listLoad = false
          //self.errorbar = true
        })
      }
    },
  }
</script>

<style scoped lang="sass">
  .similar-card
    margin: 0 32px
    text-align: unset !important
</style>